// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2OQDB","right":"Footer_right__kWOwf","buttons":"Footer_buttons__1Eawx"};